var map = {
	"./amex.svg": 20173,
	"./elo.svg": 29256,
	"./flat-rounded/alipay.svg": 18694,
	"./flat-rounded/american_express.svg": 13581,
	"./flat-rounded/code-front.svg": 97120,
	"./flat-rounded/code.svg": 23038,
	"./flat-rounded/diners_club.svg": 21367,
	"./flat-rounded/discover.svg": 4676,
	"./flat-rounded/elo.svg": 99011,
	"./flat-rounded/generic.svg": 3433,
	"./flat-rounded/hiper.svg": 47006,
	"./flat-rounded/hipercard.svg": 88437,
	"./flat-rounded/jcb.svg": 66968,
	"./flat-rounded/maestro.svg": 9615,
	"./flat-rounded/mastercard.svg": 84575,
	"./flat-rounded/mir.svg": 47525,
	"./flat-rounded/paypal.svg": 96801,
	"./flat-rounded/unionpay.svg": 48110,
	"./flat-rounded/visa.svg": 27179,
	"./hipercard.svg": 52211,
	"./mastercard.svg": 15862,
	"./visa.svg": 62429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81677;